import { useContext } from "react";
import { Toaster as Sonner, toast } from "sonner";
import ThemeContext from "@/context/ThemeContext";

// Uses the app's own ThemeContext (next-themes has no provider in this app).
// Falls back to "dark" when rendered outside ThemeProvider.
const Toaster = ({ ...props }) => {
  const ctx = useContext(ThemeContext);
  const theme = ctx?.theme === "light" ? "light" : "dark";

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-xl group-[.toaster]:rounded-xl group-[.toaster]:font-sans",
          title: "group-[.toast]:font-medium",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
